export default __webpack_public_path__ + "static/media/Shakespear.10c22517.jpg";